<template>
    <div>
         <!-- 头部 -->
       <top></top>
       <div class="main">
            <navMenu :active="active"></navMenu>
            <div class="content" v-loading.fullscreen.lock="loading">
                <div class="header_main">
	             <div class="header_title">2024营养星球奖报名-品牌企业奖</div>
	             <div class="header_step_box">
	                  <div class="step_item">
	                      <div class="step_number" :class="titleshow==1?'step_actitive':''">1</div>
	                      <div class="step_txt">
	                          <div class="txt1">填写基本信息</div>
	                          <div class="txt2" :class="titleshow==1?'txt_actitive':''">填写或确认基本信息</div>
	                      </div>
	                  </div>
	                   <div class="step_item">
	                      <div class="step_number" :class="titleshow==2?'step_actitive':''">2</div>
	                      <div class="step_txt">
	                          <div class="txt1">填写品牌信息</div>
	                          <div class="txt2" :class="titleshow==2?'txt_actitive':''">填写或确认品牌信息</div>
	                      </div>
	                  </div>
	             </div>
	            </div>
                <div class="content_main">
	            <div class="content-notice" v-if="titleshow==1">
	                <p style="color:red;">* 参评须知：</p>
	                <p>· 品牌方或工厂须成立一年以上</p>
	                <p>· 请详细填写，主办方将通过品牌传播力、美誉度、销量、创新力、行业参与度等维度，综合评定品牌的影响力和竞争力</p>
	            </div>
	            <div class="content_main_title" v-if="titleshow==1">参选企业基本信息 
	                <div class="edit-wrap" @click="editCompany">
	                    <img class="edit-icon" src="../../assets/discussion/dis_icon02.png" >修改
	                </div>
	            </div>
	            <div class="content_main_title" v-if="titleshow==2">
	                参选企业品牌信息 
	                <div class="edit-wrap" @click="editBrand">
	                    <img class="edit-icon" src="../../assets/discussion/dis_icon02.png" >修改
	                </div>
	           </div>
	            <el-form v-show="titleshow==1" :model="companyForm" ref="companyForm" :rules="companyFormRules" label-width="90px" class="demo-ruleForm" label-position="top">
	                <!--第一步 填写基本信息-->
             
                        <el-row>
    	                    <el-col :span="7">
    	                        <el-form-item label="公司名称：" prop="companyName">
                                    <el-input v-model="companyForm.companyName"  placeholder="请输入" :disabled="true"></el-input>
                                </el-form-item>
    	                    </el-col>
                            <el-col :span="3">
    	                        <el-form-item label="展位号：" prop="boothNo">
                                    <el-input v-model="companyForm.boothNo" placeholder="请输入" :disabled="true"></el-input>
                                </el-form-item>
    	                    </el-col>
    	                    <el-col :span="3">
    	                        <el-form-item label="展区：" prop="exhibitionArea">
                                    <el-input v-model="companyForm.exhibitionArea" placeholder="请输入" :disabled="true"></el-input>
                                </el-form-item>
    	                    </el-col>
    	                    <el-col :span="3">
    	                        <el-form-item label="展馆号：" prop="hallNo">
                                    <el-input v-model="companyForm.hallNo" placeholder="请输入" :disabled="true"></el-input>
                                </el-form-item>
    	                    </el-col>
	                    </el-row>
                         <el-row>
    	                    <el-col :span="5">
    	                        <el-form-item label="联系人：" prop="contacts">
                                    <el-input v-model="companyForm.contacts"  placeholder="请输入" :disabled="isCompanyEdit"></el-input>
                                </el-form-item>
    	                    </el-col>
                            <el-col :span="5">
    	                        <el-form-item label="手机号：" prop="telephoneNumber">
                                    <el-input v-model="companyForm.telephoneNumber" placeholder="请输入" :disabled="isCompanyEdit"></el-input>
                                </el-form-item>
    	                    </el-col>
    	                    <el-col :span="5">
    	                        <el-form-item label="邮箱：" prop="email">
                                    <el-input v-model="companyForm.email" placeholder="请输入" :disabled="isCompanyEdit"></el-input>
                                </el-form-item>
    	                    </el-col>
    	                 </el-row>
    	                 <el-row>
                            <el-col :span="12">
                                <el-form-item label="联系地址：" prop="address">
                                    <el-input v-model="companyForm.address" placeholder="请输入" :disabled="isCompanyEdit"></el-input>
                                </el-form-item>
                            </el-col>
                         </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="公司介绍：" prop="introduction">
                                    <el-input type="textarea" rows="4" v-model="companyForm.introduction" resize="none" placeholder="请输入" :disabled="isCompanyEdit"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
     
                    <el-form-item class="save_btn">
                        <el-button type="primary" @click="stepBtn('companyForm')">下一步</el-button>
                    </el-form-item>
	           </el-form>
                <el-form v-show="titleshow==2" :model="ruleForm" ref="ruleForm" :rules="rules" label-width="90px" class="demo-ruleForm" label-position="top">
                   <!--第二步 填写品牌信息-->
                 
                        <el-row>
    	                    <el-col :span="7">
    	                        <el-form-item label="品牌名称：" prop="name">
                                    <el-input v-model="ruleForm.name"  placeholder="请输入" :disabled="isBrandEdit"></el-input>
                                </el-form-item>
    	                    </el-col>
                            <el-col :span="3">
    	                        <el-form-item label="成立时间：" prop="establish_date">
                                    <el-date-picker
                                        :picker-options="expireTimeOPtion"
                                        :disabled="isBrandEdit"
                                        v-model="ruleForm.establish_date"
                                        type="date"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                </el-form-item>
    	                    </el-col>
	                    </el-row>
	                    <el-row>
    	                    <el-col :span="4">
    	                        <el-form-item label="年销售额：">
                                    <el-input v-model="ruleForm.sales_volume"  placeholder="请输入" :disabled="isBrandEdit"></el-input>
                                </el-form-item>
    	                    </el-col>
                            <el-col :span="4">
    	                        <el-form-item label="品牌官网：">
                                    <el-input v-model="ruleForm.web" placeholder="请输入" :disabled="isBrandEdit"></el-input>
                                </el-form-item>
    	                    </el-col>
	                    </el-row>
	                    <el-row>
    	                    <el-col :span="7">
    	                        <el-form-item label="品牌简介：" prop="description">
                                    <el-input type="textarea" rows="4" v-model="ruleForm.description" resize="none" placeholder="请输入" :disabled="isBrandEdit"></el-input>
                                </el-form-item>
    	                    </el-col>
    	                    <el-col :span="7">
    	                        <el-form-item label="品牌创新情况简介：" prop="innovate">
                                    <el-input type="textarea" rows="4" v-model="ruleForm.innovate" resize="none" placeholder="请输入" :disabled="isBrandEdit"></el-input>
                                </el-form-item>
    	                    </el-col>
	                    </el-row>
	                    <el-row>
    	                    <el-col :span="24">
    	                        <el-form-item label="历史获奖情况：">
                                    <div class="awards-upload">
                                        <el-upload 
                                            action="/" 
                                            name='imgFile'
                                             :before-upload="beforeUploadhj"
                                            list-type="picture-card"
                                            accept=".pdf, .png , .jpg, .jepg"
                                            :file-list="ruleForm.historical_awards"
                                           
                                        >
                                            <div slot="file" slot-scope="{ file }">
                                                <div>
                                                    <img
                                                    class="el-upload-list__item-thumbnail"
                                                    :src="isPDF(file.url) ? '../images/pdf_icon.jpg' : file.url"
                                                    :style="{maxWidth:isPDF(file.url) ? '75%' : '100%',maxHeight:isPDF(file.url) ? '75%' : '100%'}"
                                                    alt="" />
                                                    <span
                                                      v-if="file.status === 'success'"
                                                      class="el-upload-list__item-actions"
                                                    >
                                                      <span
                                                        class="el-upload-list__item-preview"
                                                        @click="handlePreview(file)"
                                                      >
                                                        <i class="el-icon-zoom-in"></i>
                                                      </span>
                                                      <span      
                                                        class="el-upload-list__item-delete"
                                                        @click="handleRemove(file)"
                                                      >
                                                        <i class="el-icon-delete"></i>
                                                      </span>
                                                    </span>
                                                </div>
                                              </div>
                                            <div class="upload-tip">
                                                <i>
                                                    <img class="upload-img" mode="widthFix" src="../../assets/discussion/discussion_upload.jpg" >
                                                    <div class="tips">请上传PDF或图片<br>可上传多个文件</div>
                                                </i>
                                            </div>
                                        </el-upload>
                                        <el-dialog :visible.sync="dialogVisible">
                                          <img style="max-width:80%;max-height: 500px;margin: 0 auto;" :src="Imghttp + dialogImageUrl" alt="">
                                        </el-dialog>
                                    </div>
                                </el-form-item>
    	                    </el-col>
	                    </el-row>
	                    <el-row>
    	                    <el-col :span="7">
    	                        <el-form-item label="重点新闻报道链接：">
                                    <el-input type="textarea" rows="4" v-model="ruleForm.news" resize="none" placeholder="链接以逗号分隔" :disabled="isBrandEdit"></el-input>
                                </el-form-item>
    	                    </el-col>
	                    </el-row>
	                    <el-row>
    	                    <el-col :span="24">
    	                        <el-form-item label="品牌logo（仅限一张）：" prop="logo">
                                    <div class="awards-logo">
                                        <el-upload 
                                            action="/kindeditor/php/uploadApi.php?mode=3" 
                                            :show-file-list="false"
                                            name='imgFile'
                                            :on-success="handleLogoSuccess"
                                        >   
                                            <img v-if="ruleForm.logo" :src="Imghttp + ruleForm.logo" class="avatar">
                                            <div class="upload-tip" v-else>
                                                <i>
                                                    <img class="upload-img" mode="widthFix" src="../../assets/discussion/discussion_upload.jpg" >
                                                    <div class="tips">请上传高清矢量图片</div>
                                                </i>
                                            </div>
                                        </el-upload>
                                    </div>
                                </el-form-item>
    	                    </el-col>
	                    </el-row>
	                    <div class="zh_tips1" style="margin-top:8px;">*签署承诺：（勾选确认生效）</div>
                        <div class="zh_tips_checkbox">
                            <el-checkbox v-model="checked"><span>本人经所属企业授权，确认申报参评2024营养星球奖，并承诺通过此页面提交的参评资料真实有效</span></el-checkbox>
                        </div>
                    <el-form-item class="save_btn">
                        <el-button @click="prevBtn">上一步</el-button>
                        <el-button type="primary" @click="submitForm('ruleForm', 2)" :disabled="disableds">保存并提交</el-button>
                        <el-button @click="submitForm('ruleForm', 1)" :disabled="disableds">仅保存</el-button>
                    </el-form-item>
                   
                </el-form>
            </div>
            </div>
       </div>
    </div>
</template>

<script>
import '../../style/base.css'
import top from "../../components/top.vue"; //头部
import navMenu from "../../components/navMenu.vue"; //左侧步骤条
 export default {
    name:'enterpriseAward',
    components: { top, navMenu },
    data(){
        return{
            expireTimeOPtion: {
              disabledDate(time) {
                return time.getTime() > Date.now() - 8.64e6;  //如果没有后面的-8.64e6就是不可以选择今天的 
              }
            },
		    disableds:false,
		    titleshow:1,
		    Imghttp:'https://oss.larspring.com/pharmchina',
		    companyForm: {
		        companyName:'',//公司名称
                boothNo: '',//展位号
                exhibitionArea: '',//展区
                hallNo: '',//展馆号
                contacts: '',//联系人
                telephoneNumber: '',//手机号
                email: '',//邮箱
                address: '',//联系地址
                introduction: '',//公司介绍
		    },
		    companyFormRules:{
		        companyName: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' },
                ],
                contacts: [
                    { required: true, message: '请输入联系人', trigger: 'blur' },
                ],
                telephoneNumber: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                ],
                email: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                    { type: 'email', message: '邮箱格式不正确', trigger: 'blur'}
                ],
                address: [
                    { required: true, message: '请输入联系地址', trigger: 'blur' },
                ],
                introduction: [
                    { required: true, message: '请输入公司介绍', trigger: 'blur' },
                ],
		    },
		    ruleForm:{
                name: '',//品牌名称
                establish_date: '',//成立时间
                sales_volume: '',//年销售额
                web: '',//品牌官网
                description: '',//品牌简介
                historical_awards: [],//历史获奖情况
                news: '',//重点新闻报道链接
                innovate: '',//创新简介 
                logo: '',//品牌logo
		    },
		    rules:{
		        name: [
                    { required: true, message: '请输入品牌名称', trigger: 'blur' },
                ],
                establish_date: [
                    { required: true, message: '请输入成立时间', trigger: 'blur' },
                ],
                // sales_volume: [
                //     { required: true, message: '请输入年销售额', trigger: 'blur' },
                // ],
                // web: [
                //     { required: true, message: '请输入品牌官网', trigger: 'blur' },
                // ],
                description: [
                    { required: true, message: '请输入品牌简介', trigger: 'blur' },
                ],
                // historical_awards: [
                //      { required: true, message: '请上传历史获奖情况', trigger: 'blur' },
                // ],
                // news: [
                //     { required: true, message: '请输入重点新闻报道链接', trigger: 'blur' },
                // ],
                innovate: [
                    { required: true, message: '请输入品牌创新情况简介', trigger: 'blur' },
                ],
                logo: [
                    { required: true, message: '请输入上传品牌logo', trigger: 'blur' },
                ],
		    },
		    checked:false,
		    isFirst: true,
		    brandId: '',
		    dialogImageUrl: '',// 预览图片
		    dialogVisible: false, //预览弹框
		    isCompanyEdit: true,//企业基本信息是否编辑状态
		    isBrandEdit: true,//品牌信息是否编辑状态
		    timeOperation:{}//奖项开始时间-结束时间
        }
    },
    mounted() {
            // 获取企业详情
            this.getDetails();
            // 获取品牌信息
            this.getBrandDetails();
           if(!this.ruleForm.name){
                 this.isBrandEdit=false
            }else{
                 this.isBrandEdit=true
            }
                
        },
    methods: {
		   // 获取企业信息
           getDetails(){
                axios
                    .get('api.php?m=nhnecompany.getDetail&v=3.0',{})
                        .then(res => {
                            //console.log(res, '---获取企业详情');
                            if(res.status == 200){
                                let data = res.data.rst;
                                console.log(data, '===data')
                                this.companyForm.companyName = data.companyName;
                                this.companyForm.boothNo = data.boothNo;
                                this.companyForm.exhibitionArea = data.exhibitionArea;
                                this.companyForm.hallNo = data.hallNo;
                                this.companyForm.contacts = data.contacts;
                                this.companyForm.telephoneNumber = data.telephoneNumber;
                                this.companyForm.email = data.email;
                                this.companyForm.address = data.address;
                                this.companyForm.introduction = data.introduction;
                            }
                        })
                        .catch(function (err) { 
                            //console.log(err);
                        });  
            },
            //修改企业信息
            editDetail(data){
                axios
                    .post('api.php?m=nhnecompany.editDetail&v=3.0',data)
                    .then(res => {
                        console.log(res, '---修改企业信息');
                        if(res.status == 200){
                            this.titleshow = 2;
                        }
                    })
                    .catch(function (err) { 
                        console.log(err);
                    });
            },
            // 获取品牌信息
            getBrandDetails(){
                axios
                    .post('api.php?m=nhneBrand.getDetail&v=3.0',qs.stringify({awardsid: id}))
                    .then(res => {
                        console.log(res, '---获取品牌信息');
                        if(res.status == 200){
                            let data = res.data.rst;
                            this.timeOperation = data.awards;
                            if(!data.id){
                                this.isFirst = true;
                            }else{
                                this.ruleForm.name = data.name;
                                this.ruleForm.establish_date = data.establish_date;
                                this.ruleForm.sales_volume = data.sales_volume;
                                this.ruleForm.web = data.web;
                                this.ruleForm.description = data.description;
                                let historicalAwards = [];
                                if(data.historical_awards.length > 0){
                                    data.historical_awards.forEach(item => {
                                        historicalAwards.push({url: item})
                                    })
                                    this.ruleForm.historical_awards = historicalAwards;
                                }
                                
                                this.ruleForm.news = data.news;
                                this.ruleForm.innovate = data.innovate;
                                this.ruleForm.logo = data.logo;
                                this.isFirst = false;
                                this.brandId = data.id;
                            }
                        }
                    })
                    .catch(function (err) { 
                        console.log(err);
                    });
            },
		    //点击下一步
		    stepBtn(formName){
	            this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let { companyName,contacts,telephoneNumber,email,address,introduction } = this.companyForm;
                        let data = {
                            companyName,
                            contacts,
                            telephoneNumber,
                            email,
                            address,
                            introduction
                        }
                        console.log(data, '=====data')
                        this.editDetail(qs.stringify(data))
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
		    },
		    //点击上一步
		    prevBtn(){
		        this.titleshow = 1;
		    },
		    // 品牌logo上传成功操作
            handleLogoSuccess(response, file, fileList) {
                this.ruleForm.logo = response.url;
            },
		    //  仅保存 && 保存并提交
		    submitForm(formName,type){
		        console.log(type, '====type')
		        this.$refs[formName].validate((valid) => {
                    if (valid) {
                           this.disableds = true
                          setTimeout(()=>{
                              this.disableds = false;
                          },2000)
                        //开始时间戳
                        let startime = this.timeOperation.reg_starttime;
                        //结束时间戳
                        let endtime = this.timeOperation.reg_endtime;
                        //当前时间戳
                        let timestamp = Date.now() / 1000;
                        //是否开始时间
                        if(timestamp < startime){
                            this.$message.warning(`报名未开始,开始时间${this.timeOperation.startdate}`);
                            return false
                        }
                        //是否结束时间
                        if(endtime < timestamp){
                            this.$message.warning('报名已截止');
                            return false
                        }
                        //是否勾选签署承诺
                        if(type=='2' && !this.checked){
                            this.$message.warning('请勾选签署承诺');
                            return false;
                        }
                        // 组数据
                        let { name,establish_date,sales_volume,web,description,historical_awards,news,innovate,logo } = this.ruleForm;
                        console.log(historical_awards, '======historical_awards')
                        let historicalAwards = [];
                        historical_awards.forEach(item => {
                            historicalAwards.push(item.url)
                        })
                        let data = {
                            name,
                            establish_date,
                            sales_volume,
                            web,
                            description,
                            historical_awards: JSON.stringify(historicalAwards),
                            news,
                            innovate,
                            logo,
                            awardsid: id
                        }
                        if(this.isFirst){
                            if(type == 2){
                                data.submit = 1;
                            }else{
                                data.submit = 0;
                            }
                            //第一次保存数据    
                            this.saveBrand(qs.stringify(data), type)
                        }else{
                            data.id = this.brandId;
                            if(type == 2){
                                data.submit = 1;
                            }else{
                                data.submit = 0;
                            }
                            //更新数据
                            this.updateBrand(qs.stringify(data), type)
                        }
                        
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
		        
		    },
		    //保存品牌信息
            saveBrand(data, type){
                axios
                    .post('api.php?m=nhneBrand.saveBrandData&v=3.0',data)
                    .then(res => {
                        console.log(res, '---保存品牌信息');
                        if(res.status == 200){
                            this.$message({ 
                                message: '保存成功!',
                                type: 'success'
                            });
                            setTimeout(()=> {
                                //保存成功后，跳转页面
	                            window.location.href="<?= URL('discussion.discussionindex'); ?>"
                            }, 2000)
                        }
                    })
                    .catch(function (err) { 
                        console.log(err);
                    });
            },
            //更新品牌信息
            updateBrand(data, type){
                axios
                    .post('api.php?m=nhneBrand.updateData&v=3.0',data)
                    .then(res => {
                        console.log(res, '---更新品牌信息');
                        if(res.status == 200){
                            if(res.data.errno == '0' ){
                                this.$message({ 
                                    message: '更新成功!',
                                    type: 'success'
                                });
                                setTimeout(()=> {
                                    // 保存成功后，跳转页面
		                            window.location.href="<?= URL('discussion.discussionindex'); ?>"
                                }, 2000)
                            }
                        }
                    })
                    .catch(function (err) { 
                        console.log(err);
                    });
            },
              beforeUploadhj(file){
                  // 检查文件类型
                  if(file.type == 'image/jpeg' || file.type == 'application/pdf'){
                      
                       this.dir=file.type == 'image/jpeg'?'image':'file';
                       let formData = new FormData();
                       formData.append("imgFile", file);
                       
                       axios.post('kindeditor/php/uploadApi.php?mode=3&dir='+this.dir,formData).then(res => {
                           console.log(res,"res")
                             if (res.data.errno == 0) {
                                    let data = {
                                        url: res.data.url,
                                        uid: file.uid,
                                    }
                                    this.ruleForm.historical_awards = [...this.ruleForm.historical_awards, data];
                                    this.$forceUpdate();
                                }
                                                
                        }).catch(function (err) { 
                            console.log(err);
                        });  
        
                       
                       return true
                       
                  }else{
                      this.$message.error('只能上传 JPEG JPG PNG PDF 格式的图片！');  
                       return false
                  }
            
             },
            // //上传文件及图片
            // handleSuccess(res, file, fileList) {
            //     if (res.errno == 0) {
            //         let data = {
            //             url: file.response.url,
            //             uid: file.uid,
            //         }
            //         this.ruleForm.historical_awards = [...this.ruleForm.historical_awards, data];
            //         this.$forceUpdate();
            //     }
            // },
            // 判断是否pdf
            isPDF(url) {
              if(!url){
                return false
              }
              const fileType = ['pdf']
              const index = url.lastIndexOf('.')
              const type = url.substr(index + 1)
              return fileType.indexOf(type) > -1
            },
            //删除图片／文件
            handleRemove(file) {
                console.log(file, '===file')
                this.$confirm(`确认删除文件?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    console.log()
                    this.ruleForm.historical_awards = this.ruleForm.historical_awards.filter((v) => v.url !== file.url)
                }).catch(()=>{})
            },
            //预览图片/文件
            handlePreview(file, fileList) {
                if(this.isPDF(file.url)){
                    let url = this.Imghttp + file.url;
                    window.open(url, "_blank");
                } else {
                    this.dialogImageUrl = file.url;
                    this.dialogVisible = true;
                }
            },
            //编辑企业信息状态
            editCompany(){
                console.log('123123123123')
                this.isCompanyEdit = !this.isCompanyEdit;
            },
            //编辑品牌信息状态
            editBrand(){
                this.isBrandEdit = !this.isBrandEdit;
            }
		}
 }
</script>

<style scoped>
      /* 2024.8.15 基础版本备份 */
    .awards-logo .el-upload .avatar{
        position: absolute;
        top: 50%;
        left: 50%;
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
        transform: translate(-50%, -50%);
    }
    .awards-logo .el-upload .upload-tip{
        font-size: 16px;
        box-sizing: border-box;
        padding-top: 30px;
        line-height: 24px;
    }
    .awards-logo .el-upload .upload-tip .upload-img{
        width: 34px;
        height: 34px;
        margin: 0 auto 15px;
    }
    .content_main_title{
        display: flex;
        align-items: center;
    }



.content{
    background: #fff;
    margin-right: 40px;
}
/*评奖报名首页*/
.main{
    padding: 30px 0px 30px 40px;
    box-sizing: border-box;
}

/*品牌企业奖——信息填写*/
.content_main .content-notice{
    padding: 20px;
    font-size: 14px;
    color: #000;
    line-height: 22px;
    min-height: 106px;
    background: #F8F8F8;
    border-radius: 8px;
   
    margin-bottom: 20px;
    box-sizing: border-box;
    font-family: PingFangSC, PingFang SC;
}
.save_btn .el-button {
    width: 130px;
}

.pdf_box{
    width: 358px;
    height: 68px;
    background: #FFFFFF;
    border-radius: 8px;
    margin-top: 10px;
    display: flex;
    align-items: center;
    padding: 0 15px;
    box-sizing: border-box;
}
.pdf_box img{
    width: 28px;
    height: 28px;
}

.header_title{
    font-size: 18px;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    color: #000000;
}
.header_main{
    background: #F3F4F8;
    padding: 30px 38px;
    box-sizing: border-box;
   
}
.header_step_box{
    display: flex;
    margin-top: 40px;
}
.step_item{
    display: flex;

    margin-right: 126px;
}
.step_number{
    width: 32px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    background: #BBBBBB;
    border-radius: 21px;
    font-size: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
}
.step_txt{
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    margin-left: 10px;
}
.step_txt .txt1{
    color: #000000;
    margin-bottom: 5px;
}
.step_txt .txt2{
    color: #999999;
}

.content_main{
    padding: 30px 0 ;
    box-sizing: border-box;
}
.content_main_title{
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #3D83E8;
    padding-bottom: 10px;
    border-bottom: 1px solid #3D83E9;
    margin-bottom: 30px;
}
.save_btn{
    display: flex;
    justify-content: center;
    margin-top: 160px;
}
.step_actitive{
    background: #1677FF !important;
}
.txt_actitive{
    color: #000000 !important;
}
/*图片*/
.tp_update  .el-upload-dragger{
    width: 262px !important;
    height: 128px !important;
    }
.tp_update  .el-upload--picture-card{
   /* width: 148px !important;
   height: 148px !important; */
   /*border: none !important;*/
   width: 262px !important;
    height: 128px !important;
}
.tp_update .el-icon-tip{
    display: block !important;
    font-size: 16px !important;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: rgba(153,153,153,0.88);
     margin-top: 15px;
}
.tp_update .el-upload--picture-card i{
    display: flex;
    flex-direction: column;
    width: 262px !important;
    height: 128px !important;
    align-items: center;
    justify-content: center;
    font-size: 36px;
   
}

/*pdf 和 图片*/
.pdf_update .el-upload-dragger{
     width: 262px !important;
     height: 128px !important;
}
    
.pdf_update .el-upload--picture-card{
  width: 262px !important;
     height: 128px !important;
   border: none !important;
}

.pdf_update .el-upload--picture-card i{
    display: flex;
    flex-direction: column;
    width: 262px !important;
    align-items: center;
    justify-content: center;
    font-size: 16px;
      font-size: 16px !important;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: rgba(0,0,0,0.88);
     margin-top: 8px;
}
.pdf_update .el-upload--picture-card{
    line-height: 3;
}
.discussion_upload{
    width: 34px;
    height: 32px;
    margin-top: 22px;
}
.zh_tips1{
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #FF4D4F;
    margin-bottom: 16px;
}
.zh_tips_checkbox span{
    font-size: 20px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #FF4D4F;
}

a{
    color: #FFFFFF;
}
.demo-ruleForm .el-form-item {
    padding-right: 30px;
}


.edit-icon{
    width: 35px;
    position: absolute;
    right: 30px;
    z-index: 99;
    cursor: pointer;
}

</style>

<style>
  /* 2024.8.15 基础版本备份 */
.awards-upload .el-upload--picture-card,
.awards-upload .el-upload--picture-card .upload-tip,
.awards-upload .el-upload-list--picture-card .el-upload-list__item{
    width: 262px !important;
    height: 128px !important;
}
 .awards-logo .el-upload,.awards-upload .el-upload-list .el-upload-list__item{
        width: 262px;
        height: 128px;
        background: #FFF;
        border-radius: 8px;
        position: relative;
        border: 1px dashed #E0E0E0;
    }
  
.awards-upload .el-upload--picture-card{
    background: #fff;
}
.awards-upload .el-upload--picture-card .upload-tip i{
    padding-top: 30px;
    display: inline-block;
}
.awards-upload .el-upload--picture-card .upload-tip .upload-img{
    width: 34px;
    height: 34px;
    display: block;
    margin: 0 auto 15px;
}
.awards-upload .el-upload--picture-card .upload-tip .tips{
    width: 100%;
    height: 24px;
    color: #000;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
}
.awards-upload .el-upload-list--picture-card .el-upload-list__item{
    position: relative;
}
.awards-upload .el-upload-list--picture-card .el-upload-list__item-thumbnail{
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.el-checkbox{
        display: flex;
        align-items: center;
    }
    .el-checkbox__inner{
        width: 26px;
        height: 26px;
    }
    .el-checkbox__inner::after{
        top: 5px;
        left: 10px;
        height: 9px;
        border-width: 2px;
    }
</style>